module.exports = __webpack_public_path__ + "img/entrada.3cd1700b.svg";